<lcp-header></lcp-header>


<div class="main-content-container"
  [ngClass]="'main-content-project-' + project?.fields['slug']">
  <section *ngIf="project" class="lcp-section">
    <div class="lcp-section-content">
      <div *ngIf="project.fields['title']" class="display-flex">
        <h1 class="project-title section-title margin-top-20 flex-55-not-sm margin-bottom-0">
          {{ project.fields['title'] }}
        </h1>
      </div>
      <div *ngIf="project.fields['subheader']" class="display-flex">
        <h2 class="project-subheader block-title color-text-light flex-55-not-sm"
          [innerHtml]="lcpHelper.htmlFromRichText(project.fields['subheader'])">
        </h2>
      </div>
    </div>
  </section>

  <div class="main-content project-main-content">
    <ng-container *ngIf="project">

      <lcp-media
        *ngIf="projectFeaturedMedia"
        [media]="projectFeaturedMedia"
        klass="project-image is-full">
      </lcp-media>

      <ng-container *ngIf="project.fields['tagline'] || project.fields['body']">
        <div [ngClass]="['project-row', 'project-body-section']">
          <div class="project-body-container align-self-flex-start">
            <h3 class="project-subheader text-color-light" 
              *ngIf="project.fields['tagline']"
              [innerHtml]="lcpHelper.htmlFromRichText(project.fields['tagline'])">
              <!-- {{ project.fields['tagline'] }} -->
            </h3>
          </div>
          <div class="project-body-container align-self-flex-start">
            <div class="project-body"
              *ngIf="project.fields['body']"
              [innerHtml]="lcpHelper.htmlFromRichText(project.fields['body'])">
            </div>
          </div>
        </div>
      </ng-container>
       
      <div *ngFor="let block of project.fields['blocks']"
        [ngClass]="['project-row', lcpHelper.blockClass(block)]"> 
        <!-- !!block.fields['slug'] ? block.fields['slug'] : null]"> -->

        <ng-container *ngIf="['full-width'].indexOf(block.fields['format']) > -1">
          <lcp-media
            [media]="block.fields['media'][0]"
            klass="project-image is-full">
          </lcp-media>
          <!-- <img *ngIf="block.fields['media'][0]" 
            class="project-image is-full"
            [src]="lcpHelper.urlFromMedia(block.fields['media'][0])"> -->
        </ng-container>

        <ng-container *ngIf="['two-square'].indexOf(block.fields['format']) > -1">
          <lcp-media
            [media]="block.fields['media'][0]"
            klass="project-image is-half">
          </lcp-media>
          <lcp-media
            [media]="block.fields['media'][1]"
            klass="project-image is-half">
          </lcp-media>
        </ng-container>

        <ng-container *ngIf="block.fields['format'] == 'image-block-3'">
          <lcp-media
            [media]="block.fields['media'][0]"
            klass="project-image is-half">
          </lcp-media>

          <div class="project-column">
            <lcp-media
              [media]="block.fields['media'][1]"
              klass="project-image is-full">
            </lcp-media>
            <lcp-media
              [media]="block.fields['media'][2]"
              klass="project-image is-full">
            </lcp-media>
          </div>
        </ng-container>

        <ng-container *ngIf="block.fields['format'] == 'image-block-4'">
          
          <div class="project-column">
            <lcp-media
              [media]="block.fields['media'][0]"
              klass="project-image is-full">
            </lcp-media>
            <lcp-media
              [media]="block.fields['media'][1]"
              klass="project-image is-full">
            </lcp-media>
          </div>

          <lcp-media
            [media]="block.fields['media'][2]"
            klass="project-image is-half">
          </lcp-media>
        </ng-container>


        <ng-container *ngIf="block.fields['format'] == 'image-block-5'">
          <lcp-media
            [media]="block.fields['media'][0]"
            klass="project-image is-half">
          </lcp-media>

          <div class="project-column">
            <lcp-media
              [media]="block.fields['media'][1]"
              klass="project-image is-full">
            </lcp-media>

            <div class="project-column">
              <lcp-media
                [media]="block.fields['media'][2]"
                klass="project-image is-full">
              </lcp-media>
            </div>
            <div class="project-column">
              <lcp-media
                [media]="block.fields['media'][3]"
                klass="project-image is-full">
              </lcp-media>
            </div>
          </div>
        </ng-container>


        <ng-container *ngIf="block.fields['format'] == 'image-block-6'">
          <div class="project-column">
            <lcp-media
              [media]="block.fields['media'][0]"
              klass="project-image is-full">
            </lcp-media>

            <div class="project-column">
              <lcp-media
                [media]="block.fields['media'][1]"
                klass="project-image is-full">
              </lcp-media>
            </div>
            <div class="project-column">
              <lcp-media
                [media]="block.fields['media'][2]"
                klass="project-image is-full">
              </lcp-media>
            </div>
          </div>

          <lcp-media
            [media]="block.fields['media'][3]"
            klass="project-image is-full">
          </lcp-media>
        </ng-container>

        <ng-container *ngIf="block.fields['format'] == 'image-block-7'">
          <div class="project-column is-1-4">
            <lcp-media
              [media]="block.fields['media'][0]"
              klass="project-image is-full">
            </lcp-media>
          </div>
          <div class="project-column is-3-4">
            <lcp-media
              [media]="block.fields['media'][1]"
              klass="project-image is-full">
            </lcp-media>
          </div>
        </ng-container>

        <ng-container *ngIf="block.fields['format'] == 'image-block-8'">
          <div class="project-column is-3-4">
            <lcp-media
              [media]="block.fields['media'][0]"
              klass="project-image is-full">
            </lcp-media>
          </div>
          <div class="project-column is-1-4">
            <lcp-media
              [media]="block.fields['media'][1]"
              klass="project-image is-full">
            </lcp-media>
          </div>
        </ng-container>

      </div>
    </ng-container>
  </div>
</div> 